import { motion } from "framer-motion";

const IMAGES = [
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_95ed2209-20a6-4af0-9c41-ce1277420ecb/artifacts/agdl5zcd_WhatsApp%20Image%202022-03-30%20at%2012.53.12.jpeg",
    alt: "Y-type control valve installation",
    span: "col-span-2 row-span-2",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_a0d6c2d7-fbf4-4969-b3b8-47e87e3179c6/artifacts/gbqx1svt_GGC%20Valve.jpg",
    alt: "GGC valve",
    span: "col-span-1 row-span-1",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_a0d6c2d7-fbf4-4969-b3b8-47e87e3179c6/artifacts/7672nr0i_Al-BFV.jpg",
    alt: "Aluminium butterfly valve",
    span: "col-span-1 row-span-1",
  },
  {
    src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_95ed2209-20a6-4af0-9c41-ce1277420ecb/artifacts/9bajqs7q_IMG-20220521-WA0004.jpg",
    alt: "CF8 ball valve close-up",
    span: "col-span-1 row-span-2",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_a0d6c2d7-fbf4-4969-b3b8-47e87e3179c6/artifacts/sgf9dxog_2.26%202.27.jpg",
    alt: "Y-strainer valve close-up",
    span: "col-span-2 row-span-1",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_a0d6c2d7-fbf4-4969-b3b8-47e87e3179c6/artifacts/alojnbpg_image002.jpg",
    alt: "Semiconductor component handling",
    span: "col-span-1 row-span-1",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_a0d6c2d7-fbf4-4969-b3b8-47e87e3179c6/artifacts/ompq1vas_Industrial%20Valve.jpg",
    alt: "Industrial valve series",
    span: "col-span-1 row-span-1",
  },
  {
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_a0d6c2d7-fbf4-4969-b3b8-47e87e3179c6/artifacts/kifjti23_WhatsApp%20Image%202023-03-06%20at%204.39.14%20PM.jpeg",
    alt: "Industrial valve cluster",
    span: "col-span-1 row-span-1",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

const Gallery = () => (
  <section id="gallery" className="relative bg-white border-t border-slate-200 py-28 sm:py-36">
    <div className="max-w-[1600px] mx-auto px-6 sm:px-10">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={fadeUp}
        className="mb-14 max-w-2xl"
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#1C8FC4] mb-6">03 / Gallery</p>
        <h2 className="font-heading font-bold uppercase text-[#1A2E4A] text-4xl sm:text-5xl tracking-tight">
          Field &amp; Factory
        </h2>
        <p className="mt-5 font-body text-slate-600 text-base leading-relaxed">
          Valves, actuators and installations moving across India&apos;s plants — and more.
        </p>
      </motion.div>

      <div className="grid grid-cols-2 sm:grid-cols-4 auto-rows-[180px] sm:auto-rows-[220px] gap-1 grid-flow-dense border border-slate-200">
        {IMAGES.map((img, i) => (
          <motion.div
            key={img.src}
            data-testid={`gallery-image-${i}`}
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, delay: (i % 4) * 0.08 }}
            className={`relative overflow-hidden border border-slate-200 group ${img.span}`}
          >
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-full object-cover grayscale-[40%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <span className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-[0.15em] text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              {img.alt}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
